// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"765":"641dc7ab6114dd1d","6979":"727973242bb33abd","8675":"a070c9513bea1763"}[chunkId] + ".css";
};